<template>
        <div class="size-1-3">
            <ai-form-radio-box
                ref="radioRef"
                :meta='meta.radioMeta'
                :noClass="true"
                :callbacks="{userDataChanged: changeRadio}"
            />
        </div>
        <div class="size-1-3">
            <ai-form-select-box
                :meta='props.meta.selectMeta'
                :callbacks="{userDataChanged: changeSelect}"
                :read-only="readOnlySelect"
            ></ai-form-select-box>
        </div>
        <div class="size-1-3">
            <ai-form-number-box
                :meta='props.meta.soMeta'
                :server-data='userData'
                :read-only="readOnlyInput"
                :callbacks="{userDataChanged: changeInput}"
            />
        </div>
        <div class="size-1-3">
            <ai-form-number-box
                :meta='props.meta.swMeta'
                :server-data='userData'
                :read-only="readOnlyInput"
                :callbacks="{userDataChanged: changeInput}"
            />
        </div>
</template>
<script>
export default {
    name: 'tep-itp-rasch-pot'
}
</script>
<script setup>

import { computed, inject } from 'vue';
import AiFormSelectBox from '@/components/card-component/ai-form-select-box.vue';
import AiFormRadioBox from '@/components/card-component/ai-form-radio-box.vue';
import AiFormNumberBox from '@/components/card-component/ai-form-number-box.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

const userData = inject('userData');

const readOnlyInput = computed(() => {
    return userData.value[props.meta.radioMeta.fieldNameText] !== 2 ;
});

const readOnlySelect = computed(() => {
    return userData.value[props.meta.radioMeta.fieldNameText] !== 1 ;
});

const changeSelect = (() => {
    if(props.serverData[props.meta.selectMeta.fieldNameText] !== userData.value[props.meta.selectMeta.fieldNameText]) {
        if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
    }
});

const changeRadio = (() => {
    if(props.serverData[props.meta.radioMeta.fieldNameText] !== userData.value[props.meta.radioMeta.fieldNameText]) {
        if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
    }
})

const changeInput = (() => {
    if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
})

</script>
<style scoped>

</style>
